import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_CONFIGURATION } from '../../data.const';
import {
  setCurrentConfigurationAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveConfigurationEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_CONFIGURATION),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_CONFIGURATION}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ configurationLoader: true })),
        defer(() =>
          from(
            request({ path: `configuration/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_CONFIGURATION}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentConfigurationAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_CONFIGURATION}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ configurationLoader: false }))
      );
    })
  );

export default retrieveConfigurationEpic;
